import type BaseEntity from "./base-entity";

export default interface Framework extends BaseEntity {
  name: string;
  technologies: string[];
  status: FrameworkStatus;
}

export enum FrameworkStatus {
  Draft = "draft",
  Published = "published"
}
